<div class="control-container">
    @if(imageLoading){
    <div class="div-container">
        <div class="page-title">Bilder werden geladen</div>
        <i class="fa-solid fa-image fa-fade"></i>
        <div class="image-bar">

            <img *ngFor="let article of displayedArticles; let i = index" [src]="article.image" (load)="onImageLoad(i)"
                (onerror)="onImageLoad(i)" />
            @if(!displayedArticles.length){
            <div *ngFor="let item of [].constructor(10); let i = index" [ngStyle]="{'animation-delay': (i * 0.1)+'s'}"
                class="placeholder-img"></div>
            }
        </div>
    </div>
    } @else if(progress == 0){
    <div class="div-container">
        <div class="page-title">Einstellungen</div>
        <i class="fa-solid fa-gear"></i>
        <p>Ausgewählter Shop:</p>
        <select [(ngModel)]="selectedShop" (ngModelChange)="changed = true">
            <option *ngFor="let shop of shops" [value]="shop.id">{{shop.description}}</option>
        </select>
        <p>Api Key:</p>
        <input [(ngModel)]="apiKey" placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX" (ngModelChange)="changed = true">
        <div class="buttons"><button (click)="abort()">Abbrechen</button><button
                [ngStyle]="{'opacity': changed ? 1 : 0.6}" (click)="loadImages()">Speichern</button></div>
    </div>
    } @else if(progress < 100) { <div class="div-container">
        <div class="page-title">Artikel werden aktualisiert</div>
        <i class="fa-solid fa-rotate fa-spin"></i>
        <div class="progress-bar">
            <div class="fill" [ngStyle]="{'width': progress + '%'}"></div>
            <div class="progress-text">{{progress + '%'}}</div>
        </div>
</div>
} @else {
<div class="div-container">
    <div class="page-title">Artikel werden abgespeichert</div>
    <i class="fa-solid fa-download fa-fade"></i>
    <div class="image-bar">

        <img *ngFor="let article of displayedArticles; let i = index" [src]="article.image" (load)="onImageLoad(i)"
            (onerror)="onImageLoad(i)" [id]="article.id"
            [ngClass]="fadeIn[i] ? 'fade-in' : 'fade-out'" />
    </div>
</div>
}

<div class="background"></div>
</div>